import ArrowBackIosNewRounded from '@mui/icons-material/ArrowBackIosNewRounded';
import { Link as RouterLink } from 'react-router';
import Box from '@mui/material/Box';
import { Link, SxProps } from '@mui/material';
import { TextV2, TextV2Colour } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';

type BackButtonProps = {
  parentLink: string;
  i18nKey: string;
  sx?: SxProps;
  variant?: any;
  color?: TextV2Colour | undefined;
};

const BackButton = ({
  parentLink,
  i18nKey,
  sx,
  variant = 'bodyBold',
  color = 'primary',
}: BackButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={sx}>
      <ArrowBackIosNewRounded color="primary" sx={sx} />
      <TextV2 variant={variant} color={color}>
        <Link component={RouterLink} to={parentLink}>
          {t(i18nKey)}
        </Link>
      </TextV2>
    </Box>
  );
};

export default BackButton;
